import { useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import { Menu } from 'lucide-react'
import { Sheet, SheetContent, SheetTitle } from '@/components/ui/sheet'
import { Button } from '@/components/ui/button'
import { Logo } from '@/components/shared/Logo'
import { SidebarContents } from './Sidebar'

/**
 * Mobile chrome: a sticky top bar with a hamburger that opens the same nav the
 * desktop sidebar shows.
 *
 * A bottom tab bar (what voyp-webapp uses) does not fit here — the console has
 * eight sections against the consumer app's five.
 */
export function MobileNav({ email, role }: { email?: string; role?: string }) {
  const [open, setOpen] = useState(false)
  const location = useLocation()

  // Close on navigation, including browser back/forward, not just link clicks.
  useEffect(() => setOpen(false), [location.pathname])

  return (
    <>
      <header className="sticky top-0 z-30 flex items-center gap-2 border-b bg-sidebar/95 px-3 py-2 backdrop-blur md:hidden">
        <Button
          variant="ghost"
          size="icon"
          aria-label="Open navigation"
          onClick={() => setOpen(true)}
        >
          <Menu className="size-5" />
        </Button>
        <Logo className="size-5" />
        <span className="font-display text-sm font-semibold tracking-tight">VOYP Admin</span>
      </header>

      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="left" className="w-64 p-0 pt-10">
          <SheetTitle className="sr-only">Navigation</SheetTitle>
          <SidebarContents email={email} role={role} onNavigate={() => setOpen(false)} />
        </SheetContent>
      </Sheet>
    </>
  )
}
